<template>
   <b-form-group>
    <label v-if="label != ''">{{label}}</label>
    <div class="relative">
      <b-form-select 
        :plain="true" 
        :options="options" 
        v-model="state" 
        text-field="Name" 
        value-field="Value" 
        @input="change" 
        :name="name" 
        :id="name"
      />
    </div>
    <div v-if="formHandle.$error">
      <div class="invalid-feedback d-block" v-for="error in errors" :key="error">{{ errorMessage[error] }}</div>
    </div>
  </b-form-group>
</template>

<script>

export default {
  data: () => {
    return {
      state: ''
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: []
    },
    model: {
      type: String | Number
    },
    name: {
      type: String,
      default: ''
    },
    handler: {
      type: Array | Object
    },
    formData: {
      type: Array | Object
    }
  },
  model: {
    prop: 'model',
    event: 'updateModel'
  },
  created () {
    this.state = this.model
  },
  methods: {
    change () {
      this.$emit('updateModel', this.state)
      this.$emit('change')
    }
  },
  watch: {
    'model': function () {
      this.state = this.model
    }
  },
  computed: {
    errors: function () {
      return Object.getOwnPropertyNames(this.formHandle).filter(x => {
        return this.formHandle[x] === false && x[0] !== '$'
      })
    },
    formHandle: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.handler.form)
      return data
    },
    errorMessage: function () {
      let data = this.name.split('.').reduce((acc, curr) => {
        return acc[curr]
      }, this.formData.errorMessages)
      return data
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/custom/PSelect.vue